import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-225px" }, "Directs"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Name"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Points")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("table", _hoisted_3, [
            _hoisted_4,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                  _createVNode("td", null, _toDisplayString(item.usid), 1),
                  _createVNode("td", null, _toDisplayString(item.fullname), 1),
                  _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(Number(item.points).toFixed(2))), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}